function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

function deepClone<T>(value: T): T {
  if (typeof structuredClone === 'function') return structuredClone(value)
  return JSON.parse(JSON.stringify(value)) as T
}

export function setBrandingPath<T extends object>(branding: T, path: string, value: unknown): T {
  const next = deepClone(branding)
  const parts = path.split('.')
  let current = next as Record<string, unknown>

  parts.forEach((part, index) => {
    if (index === parts.length - 1) {
      current[part] = value
      return
    }
    if (!isPlainObject(current[part])) current[part] = {}
    current = current[part] as Record<string, unknown>
  })

  return next
}
